// extracted by mini-css-extract-plugin
module.exports = {"HeroImageWrapper":"HeroImage_HeroImageWrapper__zzYGs"};